// The company's front door (30-day row 31): the office's room. What the company has in this room, each a way in,
// read off the manifests (only modules this company has and this role may open), plus the core's own settings pages.
import { Link } from 'react-router';
import { navFor } from '@tradeview/core';
import { Head, Icon } from '../sdk';
import { useAuth } from '../auth';
import { useCompanyProfile } from '../app/company';

const CORE: Array<{ to: string; label: string; icon: string; sub: string; office?: boolean }> = [
  { to: '/settings/team', label: 'Team', icon: 'users', sub: 'people, roles, invites', office: true },
  { to: '/settings/contacts', label: 'Contacts', icon: 'users', sub: 'GCs and vendors', office: true },
  { to: '/settings/company', label: 'Company', icon: 'settings', sub: 'the brand and the standard text', office: true },
  { to: '/settings/followups', label: 'Follow-ups', icon: 'bell', sub: 'the office schedules', office: true },
  { to: '/modules', label: 'Modules', icon: 'grid', sub: 'what is on, trials, locks' },
  { to: '/settings', label: 'Settings', icon: 'settings', sub: 'everything else' },
];
const OFFICE = ['admin', 'owner', 'controller', 'office_admin', 'pm', 'estimator', 'sales'];

export function CompanyHome() {
  const { session } = useAuth();
  const role = session?.role ?? null;
  const profile = useCompanyProfile();
  const items = navFor('desktop', role, session?.entitlements ?? null).filter(n => n.room === 'company');
  const office = !!role && OFFICE.includes(role);
  const name = profile.data?.name || 'The company';
  return (
    <div className="flex flex-col gap-2.5 pb-24">
      <Head title={name} sub="The company's room: what runs across every job" />
      {items.length > 0 && <div className="grid grid-cols-2 md:grid-cols-4 gap-2">
        {items.map(n => <Link key={n.id} to={n.route} className="card py-3 flex items-center gap-3 min-w-0"><div className="ic ic-acc shrink-0"><Icon name={n.icon} size={18} /></div><div className="min-w-0"><b className="block font-head font-bold truncate">{n.label}</b><small className="block text-[12px] text-muted truncate">{n.moduleId === n.id ? 'the module' : 'the module’s company view'}</small></div></Link>)}
      </div>}
      <div className="card py-1">
        <h4 className="lbl m-0 mt-1.5 mb-1">Set up</h4>
        {CORE.filter(c => !c.office || office).map(c => <Link key={c.to} to={c.to} className="lrow"><div className="ic shrink-0"><Icon name={c.icon} size={18} /></div><div className="min-w-0 flex-1"><b className="block font-head font-bold truncate">{c.label}</b><small className="block text-[12.5px] text-muted truncate">{c.sub}</small></div><Icon name="chevron" size={16} className="text-muted shrink-0" /></Link>)}
      </div>
      <p className="m-0 text-[12.5px] text-muted">Each module's company-wide view sits here; a module the company does not have shows nothing.</p>
    </div>
  );
}
